import CreateTeam from "@/assets/svg/task/create-team.svg";
import ExecuteWork from "@/assets/svg/task/execute-work.svg";
import PremiumPlan from "@/assets/svg/task/premium-plan.svg";
import TrackResults from "@/assets/svg/task/track-results.svg";

export default function HowItWorks() {
  return (
    <div
      id="how-it-works"
      className="lg:py-10 mx-auto md:w-[92%] space-y-12 md:space-y-20 4xl:max-w-[100rem] relative overflow-hidden"
    >
      <div className="space-y-4 text-center px-8">
        <h1 className="text-4xl md:text-5xl text-primaryLight">How it works</h1>
        <p className="text-[#EDE9FE] max-w-3xl mx-auto text-sm md:text-lg">
          Enfinitask simplifies the way creators and agencies get things done by
          connecting them with skilled talents for channel management, video
          editing, and thumbnail design.
        </p>
      </div>
      <div className="flex flex-col lg:flex-row items-stretch gap-10 lg:gap-12">
        {/* Left Column */}
        <div className="w-full h-full space-y-10 lg:space-y-40">
          {/* Card 1 */}
          <div className="w-full h-[330px] lg:h-[480px] relative bg-blend-color-dodge rounded-tl-[20px] rounded-tr-[20px] border-l border-r border-t border-neutral-700 overflow-hidden p-8 space-y-10 ml-8 lg:ml-0">
            <div className="space-y-2">
              <h1 className="text-primaryLight text-2xl md:text-3xl">
                1. Create your team
              </h1>
              <p className="text-white text-sm lg:text-base">
                Pick the talents you need from our curated role library and
                start building your dream team.
              </p>
            </div>
            <img
              src={CreateTeam}
              className="absolute bottom-0 right-0 w-[310px] lg:w-[640px]"
              alt="Image"
            />
          </div>

          {/* Card 2 (mobile visible, desktop hidden) */}
          <div className="w-full h-[330px] lg:h-[480px] relative lg:hidden bg-blend-color-dodge rounded-tl-[20px] rounded-tr-[20px] border-l border-r border-t border-neutral-700 overflow-hidden p-8 space-y-10 -ml-8">
            <div className="space-y-2 text-right">
              <h1 className="text-primaryLight text-2xl md:text-3xl">
                2. Execute the work
              </h1>
              <p className="text-white text-sm">
                Our certified pros handle the tasks—fast, precise, and
                hassle-free.
              </p>
            </div>
            <img
              src={ExecuteWork}
              className="absolute bottom-0 right-0 h-44 lg:h-72"
              alt="Image"
            />
          </div>

          {/* Card 3 (desktop only) */}
          <div className="w-full h-[330px] lg:h-[480px] relative hidden lg:block bg-blend-color-dodge rounded-tl-[20px] rounded-tr-[20px] border-l border-r border-t border-neutral-700 overflow-hidden p-8 space-y-10">
            <div className="space-y-2">
              <h1 className="text-primaryLight text-2xl md:text-3xl">
                3. Track Results
              </h1>
              <p className="text-white">
                See what’s working in real time with clear updates and
                measurable outcomes.
              </p>
            </div>
            <img
              src={TrackResults}
              className="absolute bottom-0 right-0 h-72 lg:h-[355px]"
              alt="Image"
            />
          </div>
        </div>

        {/* Right Column */}
        <div className="w-full h-full space-y-10 lg:space-y-40 lg:pt-28">
          {/* Card 3 (mobile only) */}
          <div className="w-full h-[330px] lg:h-[480px] relative lg:hidden bg-blend-color-dodge rounded-tl-[20px] rounded-tr-[20px] border-l border-r border-t border-neutral-700 overflow-hidden p-8 space-y-10 ml-8 lg:ml-0">
            <div className="space-y-2">
              <h1 className="text-primaryLight text-2xl md:text-3xl">
                3. Track Results
              </h1>
              <p className="text-white text-sm">
                See what’s working in real time with clear updates and
                measurable outcomes.
              </p>
            </div>
            <img
              src={TrackResults}
              className="absolute bottom-0 right-0 h-44"
              alt="Image"
            />
          </div>

          {/* Card 2 (desktop only) */}
          <div className="w-full h-[330px] lg:h-[480px] relative hidden lg:block bg-blend-color-dodge rounded-tl-[20px] rounded-tr-[20px] border-l border-r border-t border-neutral-700 overflow-hidden p-8 space-y-10">
            <div className="space-y-2">
              <h1 className="text-primaryLight text-2xl md:text-3xl">
                2. Execute the work
              </h1>
              <p className="text-white">
                Our certified pros handle the tasks—fast, precise, and
                hassle-free.
              </p>
            </div>
            <img
              src={ExecuteWork}
              className="absolute bottom-0 right-0 h-80"
              alt="Image"
            />
          </div>

          {/* Card 4 */}
          <div className="w-full h-[330px] lg:h-[480px] relative bg-blend-color-dodge rounded-tl-[20px] rounded-tr-[20px] border-l border-r border-t border-neutral-700 overflow-hidden p-8 space-y-10 -ml-8 lg:ml-0">
            <div className="space-y-2 text-right lg:text-left">
              <h1 className="text-primaryLight text-2xl md:text-3xl">
                4. Reinvest, hire more, grow more
              </h1>
              <p className="text-white">
                Scale smarter: reinvest savings, expand your team, and unlock
                new growth opportunities.
              </p>
            </div>
            <img
              src={PremiumPlan}
              className="absolute left-1/2 -translate-x-1/2 h-36 lg:h-72"
              alt="Image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
